import client from "../client/client";

class PortfolioSearchService {
	getPortfoliosSearchById({ portfolioId, page, limit, payload }, cancelToken) {
		return client.post(`/portfolios/pages/${portfolioId}`, {
			payload,
			params: { page, limit },
			config: { cancelToken },
		});
	}

	getMyPortfolios(cancelToken) {
		return client.get("/portfolios/me", {
			config: { cancelToken },
		});
	}

	getMyPortfoliosFilters(portfolioId, cancelToken) {
		return client.get(`/portfolios/pages/${portfolioId}/filters`, {
			config: { cancelToken },
		});
	}

	getMyPortfoliosFiltersByUUIDWithFilters({ portfolioId, uuid }, filters, cancelToken) {
		return client.post(`/portfolios/pages/${portfolioId}/fields/${uuid}`, {
			payload: filters,
			config: { cancelToken },
		});
	}

	getMultipleSearchByPortfolio({ portfolioId, limit, page, payload }, cancelToken) {
		return client.post(`/portfolios/${portfolioId}/search`, {
			config: { cancelToken },
			params: { page, limit },
			payload,
		});
	}

	getAllBuContract(cancelToken) {
		return client.post("/veolia", {
			config: { cancelToken },
		});
	}

	getAllBUsWithAdminRole(cancelToken) {
		return client.get("/veolia/admins", {
			config: { cancelToken },
		});
	}

	getFieldPossibleValues({ pageId, uuid }, cancelToken) {
		return client.post(`/portfolios/pages/${pageId}/fields/${uuid}`, {
			config: { cancelToken },
		});
	}
}
export default new PortfolioSearchService();
